import { Controller } from '@hotwired/stimulus'

export default class TooltipController extends Controller {
  connect() {
    this.tooltip = new window.bootstrap.Tooltip(this.element);
  }

  disconnect() {
    this.tooltip?.dispose();
    this.tooltip = null;
  }
}
